import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import WhatWeEdit from './WhatWeEdit.js';
const styles = {}
class WeCanEdit extends Component{
    render() {
        return(
            <div className="wecanedit-wrap">
                <div className="wecanedit-wrap2 wecanedit">
                    <div className="">
                        <div style={{height:'64px'}}></div>
                        <h1 className="text-center">WHAT CAN WE EDIT FOR YOU?</h1>
                        <div style={{height:'14px'}}></div>
                        <WhatWeEdit></WhatWeEdit>
                        <div style={{height:'92px'}}></div>
                        <a href="/get-started">
                            <div className="get-started-btn get-started-blue text-center large-6 large-offset-3 medium-8 medium-offset-2 small-12">
                                EDIT MY PAPER NOW!
                            </div>
                        </a>
                        <div style={{height:'64px'}}></div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(
)(WeCanEdit);



// WEBPACK FOOTER //
// ./src/components/pages/home/WeCanEdit.js